import { Upsell } from "@/@types/Upsell";
import { isStaging } from "@/utils/isStaging";

export const bodyScript = (upsell: Upsell) => {
  return `<div data-mndpay-render="${upsell?.id}"${isStaging ?  ' data-env="dev"' : ''}></div>`;
};

export const externalScript = () => {
  return `<script src="https://upsell.mundpay.com/script-v2.js" defer async></script>`;
};
